import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return <>
    <section className="footer-section common-padding pb-0">
      <Container>
        <Row>
          <Col md={6} lg={5}>
            <div className="footer-box under-content">
              <Link to="https://mindreset.app/" target="_blank">
                <img src={require("../assets/images/footer-logo.png")} alt="img" />
              </Link>
              <p>Boost Your Team's Productivity with Mind Reset. Reduce burnout and improve overall well-being in just 2 minutes a day </p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={2}>
            <div className="footer-box">
              <a href="#top">Home</a>
              <a href="#burnout-problem">Burnout Problem</a>
              <a href="#about-us">About Us</a>
            </div>
          </Col>
          <Col xs={6} md={3} lg={2}>
            <div className="footer-box">
              <a href="#solution">Solution</a>
              <a href="#roi-main-calculator">ROI Calculator</a>
              <a href="#pricing">Pricing</a>
            </div>
          </Col>
          <Col sm={12} md={6} lg={3}>
            <div className="footer-box footer-btns">
              <h5>Download</h5>
              <div className="action-btns">
                <Link to="https://mindreset.app/" target="_blank">
                  <img className="mt-3" src={require("../assets/images/app-store.svg").default} alt="img" />
                </Link>
                <Link to="https://mindreset.app/" target="_blank">
                  <img src={require("../assets/images/google-store.svg").default} alt="img" />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <div className="copyright-section">
          <Row>
            <Col md={6}>
              <p className="copyright-txt">© 2021 <Link to="https://mindreset.app/" target="_blank" className="text-decoration-underline ms-0 me-0">MindReset</Link> All Rights Reserved.</p>
            </Col>
            <Col md={6}>
              <div className="text-right">
                <Link to="">Terms & Conditions</Link>
                <Link to="">Privacy & Policy</Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>

  </>;
};
export default Footer;
